import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

/**
 * @param {Array<Object>}           pairablePrinters          list of printer to display in the select
 * @param {Object}                  selectedPrinter           selected printer
 * @param {Function}                changeSelectedPrinter     action for changing selected printer
 */
export default class PrinterModelSelect extends Component {
  @tracked currentSelectedPrinter;

  constructor() {
    super(...arguments);
    this.currentSelectedPrinter = this.args.selectedPrinter;
  }
}
